// extracted by mini-css-extract-plugin
export default {"background":"who_background__PNo2o"};